export default __webpack_public_path__ + "static/media/5_1_5.6a0b16c0.png";